<template>
  <ModalDialog
    ref="dialog"
    title="Order Item View"
    icon="fa-ruler-combined"
    sizeClass="modal-xl"
    :showFooter="false"
  >
    <div>
      <Spinner v-if="loading" />
      <div class="text-center text-danger" v-if="loadingError">{{loadingError}}</div>

      <div v-if="!loading && order" class="order-editor-app-dialog-viewer">
        <OrderEditorApp 
          :editing="false"
          :showCloseButton="false"
          :orderId="orderId"
          :value="viewingOrderItemList"
        />
      </div>

    </div>
  </ModalDialog>
</template>

<script>
import ModalDialog from '@/components/modalDialog.vue'
import modalDialog from '@/mixins/modalDialog'

import orderItemMixin from '@/modules/orders/mixins/orderItemMixin'

// Glass Designer Dependencies
import OrderEditorApp from '@glass-designer/views/app'

export default {
  name: 'OrderItemEditorViewerDialog',
  mixins: [
    modalDialog,
    orderItemMixin
  ],
  components: {
    ModalDialog,
    OrderEditorApp
  },
  props: {
    orderId: Number,
    orderItemId: Number
  },
  data() {
    return {
      loading: false,
      loadingError: '',
      order: null,
      viewingOrderItemList: []
    }
  },  
  mounted() {
  },
  methods: {
    show(params) {
      this.requestData()

      return modalDialog.methods.show.call(this, params)
    },
    onClosed() {
      this.modalClosed(false)
    },

    requestData() {
      this.loading = true
      this.loadingError = ''

      this.$apiService.ordersService.getOrder(this.orderId)
      .then(response => {
        this.order = response.data

        // Get the glass item & child items for the specific order item we're showing
        // Ignore the rest of the order items in the order
        this.viewingOrderItemList = this.getItemGroupListForItem(this.order.orderItems, this.orderItemId)
      })
      .catch(err => {
        console.error(err)
        this.loadingError = 'Error loading order'
      })
      .finally(() => {
        this.loading = false
      })
    }
  }
}
</script>